(() => {
  const longDateFormatter = new Intl.DateTimeFormat("fr-CA", {
    dateStyle: "long",
    timeStyle: "short",
    timeZone: "America/Toronto",
  });
  const shortDateFormatter = new Intl.DateTimeFormat("fr-CA", {
    day: "numeric",
    month: "short",
    timeZone: "America/Toronto",
  });

  function getPreloadedTracking() {
    const params = new URLSearchParams(window.location.search);
    return params.get("nums") || params.get("tracking") || "";
  }

  function createElement(tag, className, text) {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function formatDate(value, formatter = longDateFormatter) {
    if (!value) return "";
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? "" : formatter.format(date);
  }

  function progressIcon(stepId) {
    const icon = createElement("span", "vaillance-tracking__progress-icon");
    icon.setAttribute("aria-hidden", "true");
    const paths = {
      preparation: '<path d="M3 5.5h18v15H3z"/><path d="M7 3v5M17 3v5M3 10h18M8 14h3M8 18h7"/>',
      prise_en_charge: '<path d="M3 5.5h18v15H3z"/><path d="M7 3v5M17 3v5M3 10h18M8 14h3M8 18h7"/>',
      transit: '<path d="M3 7h11v9H3z"/><path d="M14 10h3l3 3v3h-6zM6 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/>',
      dernier_kilometre: '<path d="M12 21s6-5.25 6-11a6 6 0 1 0-12 0c0 5.75 6 11 6 11Z"/><circle cx="12" cy="10" r="2"/>',
      livraison: '<circle cx="12" cy="12" r="8"/><path d="m8.5 12 2.2 2.2 4.8-4.8"/>',
    };
    icon.innerHTML = `<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">${paths[stepId] || paths.transit}</svg>`;
    return icon;
  }

  function renderError(result, message) {
    result.hidden = false;
    result.className = "vaillance-tracking__result vaillance-tracking__result--error";
    result.replaceChildren(createElement("p", "", message));
  }

  function renderLoading(result) {
    result.hidden = false;
    result.className = "vaillance-tracking__result vaillance-tracking__result--loading";
    result.setAttribute("aria-busy", "true");
    const spinner = createElement("span", "vaillance-tracking__spinner");
    spinner.setAttribute("aria-hidden", "true");
    result.replaceChildren(
      spinner,
      createElement("p", "vaillance-tracking__loading-copy", "Recherche de votre suivi…"),
    );
  }

  function renderProgress(tracking) {
    const list = createElement("ol", "vaillance-tracking__progress");
    const steps = tracking.progress || [];
    steps.forEach((step, index) => {
      const nextStep = steps[index + 1];
      const reachesDelivery = step.state === "completed" && nextStep?.id === "livraison" && nextStep?.state === "current";
      const item = createElement("li", `vaillance-tracking__progress-step vaillance-tracking__progress-step--${step.state} vaillance-tracking__progress-step--${step.id}${reachesDelivery ? " vaillance-tracking__progress-step--completed-to-delivery" : ""}`);
      item.append(progressIcon(step.id));
      const text = createElement("div", "vaillance-tracking__progress-copy");
      text.append(createElement("p", "vaillance-tracking__progress-label", step.label));
      const date = formatDate(step.occurredAt, shortDateFormatter);
      if (date) text.append(createElement("p", "vaillance-tracking__progress-date", date));
      item.append(text);
      list.append(item);
    });
    return list;
  }

  function renderEvents(tracking) {
    const events = createElement("section", "vaillance-tracking__events", "");
    events.setAttribute("aria-label", "Historique du suivi");
    const title = createElement("h4", "vaillance-tracking__section-title", "Historique du suivi");
    const list = createElement("ol", "vaillance-tracking__event-list");
    const source = tracking.events || tracking.timeline || [];
    source.forEach((event) => {
      const item = createElement("li", `vaillance-tracking__event vaillance-tracking__event--${event.state}`);
      const marker = createElement("span", "vaillance-tracking__event-marker");
      marker.setAttribute("aria-hidden", "true");
      const copy = createElement("div", "vaillance-tracking__event-copy");
      const timestamp = formatDate(event.occurredAt);
      if (timestamp) copy.append(createElement("p", "vaillance-tracking__event-time", timestamp));
      copy.append(createElement("p", "vaillance-tracking__event-label", event.label));
      item.append(marker, copy);
      list.append(item);
    });
    events.append(title, list);
    return events;
  }

  function renderSentMessages(tracking) {
    const messages = tracking.messages || [];
    if (messages.length === 0) return null;
    const section = createElement("section", "vaillance-tracking__messages");
    section.setAttribute("aria-label", "Messages envoyés");
    section.append(createElement("h4", "vaillance-tracking__section-title", "Messages de notre équipe"));
    const list = createElement("ol", "vaillance-tracking__message-list");
    messages.forEach((message) => {
      const item = createElement("li", "vaillance-tracking__message");
      const timestamp = formatDate(message.sentAt);
      if (timestamp) item.append(createElement("p", "vaillance-tracking__message-time", `Courriel envoyé le ${timestamp}`));
      item.append(createElement("h5", "vaillance-tracking__message-subject", message.subject));
      const body = createElement("p", "vaillance-tracking__message-body", message.body);
      item.append(body);
      list.append(item);
    });
    section.append(list);
    return section;
  }

  function renderProducts(tracking) {
    const items = tracking.products || [];
    if (items.length === 0) return null;
    const products = createElement("aside", "vaillance-tracking__products");
    products.setAttribute("aria-label", "Produits de la commande");
    products.append(createElement("h4", "vaillance-tracking__section-title", "Produits"));
    const list = createElement("ul", "vaillance-tracking__product-list");
    items.forEach((product) => {
      const item = createElement("li", "vaillance-tracking__product");
      const visual = createElement("span", "vaillance-tracking__product-visual");
      if (product.imageUrl) {
        const image = document.createElement("img");
        image.className = "vaillance-tracking__product-image";
        image.src = product.imageUrl;
        image.alt = "";
        image.loading = "lazy";
        visual.append(image);
      } else {
        visual.append(createElement("span", "vaillance-tracking__product-image vaillance-tracking__product-image--placeholder"));
      }
      visual.append(createElement("span", "vaillance-tracking__product-badge", String(product.quantity)));
      const copy = createElement("div", "vaillance-tracking__product-copy");
      copy.append(createElement("p", "vaillance-tracking__product-title", product.title));
      item.append(visual, copy);
      list.append(item);
    });
    products.append(list);
    return products;
  }

  function buildShareUrl(trackingNumber) {
    const url = new URL(window.location.href);
    url.searchParams.set("nums", trackingNumber);
    url.searchParams.delete("tracking");
    return url;
  }

  function renderShareLink(trackingNumber) {
    if (!trackingNumber) return null;
    const share = createElement("div", "vaillance-tracking__share");
    share.append(createElement("p", "vaillance-tracking__share-label", "Lien de suivi"));
    const row = createElement("div", "vaillance-tracking__share-row");
    const shareUrl = buildShareUrl(trackingNumber).toString();
    const copy = document.createElement("button");
    copy.type = "button";
    copy.className = "vaillance-tracking__share-copy";
    copy.textContent = "Copier le lien";
    copy.addEventListener("click", async () => {
      try {
        await navigator.clipboard.writeText(shareUrl);
        copy.textContent = "Lien copié";
        window.setTimeout(() => { copy.textContent = "Copier le lien"; }, 1800);
      } catch (_error) {
        copy.textContent = "Copie impossible";
      }
    });
    row.append(copy);
    share.append(row);
    return share;
  }

  function renderTracking(result, tracking) {
    result.hidden = false;
    result.className = "vaillance-tracking__result";
    result.removeAttribute("aria-busy");

    const order = tracking.orderNumber
      ? createElement("h3", "vaillance-tracking__order", `Commande ${tracking.orderNumber}`)
      : null;
    const progress = renderProgress(tracking);
    const content = createElement("div", "vaillance-tracking__result-content");
    const main = createElement("div", "vaillance-tracking__result-main");
    const isDelivered = (tracking.progress || []).some((step) => step.id === "livraison" && step.state === "current");
    const status = createElement("p", `vaillance-tracking__status${isDelivered ? " vaillance-tracking__status--delivered" : ""}`, `Statut : ${tracking.statusLabel}`);
    const headline = createElement("h4", `vaillance-tracking__headline${isDelivered ? " vaillance-tracking__headline--delivered" : ""}`, tracking.headline);
    const detail = createElement("p", "vaillance-tracking__detail", tracking.detail);
    const meta = createElement("div", "vaillance-tracking__meta");

    if (tracking.trackingNumber) {
      const number = createElement("span", "");
      number.append("Numéro de suivi principal : ");
      number.append(createElement("strong", "", tracking.trackingNumber));
      meta.append(number);
    }
    if (tracking.carrier) {
      const carrier = createElement("span", "");
      carrier.append("Transporteur local : ");
      carrier.append(createElement("strong", "", tracking.carrier));
      meta.append(carrier);
    }
    if (tracking.lastMileTracking) {
      const localTracking = createElement("span", "");
      localTracking.append("Numéro de suivi local : ");
      localTracking.append(createElement("strong", "", tracking.lastMileTracking));
      meta.append(localTracking);
    }
    if (meta.childNodes.length > 0) main.append(status, headline, detail, meta);
    else main.append(status, headline, detail);
    const shareLink = renderShareLink(tracking.trackingNumber);
    if (shareLink) main.append(shareLink);
    main.append(renderEvents(tracking));
    const messages = renderSentMessages(tracking);
    if (messages) main.append(messages);
    const products = renderProducts(tracking);
    if (products) content.append(main, products);
    else {
      content.classList.add("vaillance-tracking__result-content--without-products");
      content.append(main);
    }

    const nodes = [];
    if (order) nodes.push(order);
    nodes.push(progress, content);
    result.replaceChildren(...nodes);
  }

  function init(root) {
    const form = root.querySelector(".vaillance-tracking__form");
    const result = root.querySelector("[data-result]");
    const trackingInput = form.querySelector("[name=tracking]");
    const orderInput = form.querySelector("[name=orderNumber]");
    const proofInput = form.querySelector("[name=customerProof]");
    const buttons = Array.from(form.querySelectorAll("button[data-lookup-mode]"));
    const trackingButton = form.querySelector("button[data-lookup-mode=tracking]");
    // Le Worker Cloudflare ne reçoit qu'une projection assainie de suivi. Il ne
    // contacte jamais le dashboard privé ni Shopify depuis le navigateur.
    const gatewayUrl = (root.dataset.gatewayUrl || "").replace(/\/$/, "");
    const preloadedTracking = getPreloadedTracking();
    let requestedMode = "";

    if (preloadedTracking) trackingInput.value = preloadedTracking;

    buttons.forEach((button) => {
      button.addEventListener("click", () => {
        requestedMode = button.dataset.lookupMode || "";
      });
    });

    function resolveMode(event) {
      const submitter = event.submitter;
      if (submitter?.dataset?.lookupMode) return submitter.dataset.lookupMode;
      if (requestedMode) return requestedMode;
      return trackingInput.value.trim() ? "tracking" : "order";
    }

    function setPending(activeButton, pending) {
      buttons.forEach((button) => {
        if (!button.dataset.defaultLabel) button.dataset.defaultLabel = button.textContent || "Suivre";
        button.disabled = pending;
        button.textContent = pending && button === activeButton ? "Recherche…" : button.dataset.defaultLabel;
      });
    }

    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!gatewayUrl || !/^https:\/\/[a-z0-9.-]+\.workers\.dev$/i.test(gatewayUrl)) {
        renderError(result, "Le suivi est temporairement indisponible. Veuillez réessayer plus tard.");
        return;
      }

      const mode = resolveMode(event);
      const body = new URLSearchParams();
      const activeButton = mode === "order"
        ? form.querySelector("button[data-lookup-mode=order]")
        : trackingButton;

      if (mode === "tracking") {
        const tracking = trackingInput.value.trim();
        if (!tracking) {
          trackingInput.focus();
          renderError(result, "Entrez votre numéro de suivi.");
          return;
        }
        body.set("tracking", tracking);
      } else {
        const orderNumber = orderInput.value.trim();
        const customerProof = proofInput.value.trim();
        if (!orderNumber || !customerProof) {
          (!orderNumber ? orderInput : proofInput).focus();
          renderError(result, "Entrez votre numéro de commande et l’adresse e-mail ou le téléphone associé.");
          return;
        }
        body.set("orderNumber", orderNumber);
        body.set("customerProof", customerProof);
      }

      setPending(activeButton, true);
      renderLoading(result);

      try {
        const response = await fetch(`${gatewayUrl}/api/lookup`, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
          body: body.toString(),
          credentials: "same-origin",
        });
        const payload = await response.json().catch(() => null);
        if (!response.ok || !payload?.ok) {
          renderError(result, payload?.message || "Aucun suivi n’a été trouvé avec ces informations.");
          return;
        }
        if (mode === "tracking") {
          const shareUrl = buildShareUrl(trackingInput.value.trim());
          // Shopify conserve parfois l’URL dans une navigation interne; une
          // navigation explicite garantit que le lien visible est partageable.
          if (shareUrl.toString() !== window.location.href) {
            window.location.assign(shareUrl.toString());
            return;
          }
        }
        renderTracking(result, payload.tracking);
      } catch (_error) {
        renderError(result, "Le suivi est temporairement indisponible. Veuillez réessayer plus tard.");
      } finally {
        requestedMode = "";
        setPending(activeButton, false);
      }
    });

    // Les liens déjà envoyés par le Customer Service, par exemple
    // /fr/pages/suivi-de-commande-fr?nums=YT..., doivent afficher le suivi
    // dès l’ouverture. Cette lecture n’amorce jamais un scan.
    if (preloadedTracking && trackingButton) {
      window.setTimeout(() => form.requestSubmit(trackingButton), 0);
    }
  }

  document.querySelectorAll(".vaillance-tracking").forEach(init);
})();
